export default __webpack_public_path__ + "2470e31dbfcde743abe9dd4eb2f86754.png";